import { ERROR_TEXT, parseError } from "../../types/Error/Errors.ts";

const ErrMessage = ({ message }: { message: string }) => {
  const error = parseError(message);
  return (
    <div className="flex items-center gap-2">
      <div className="inline-grid *:[grid-area:1/1]">
        <div className="status status-error animate-ping"></div>
        <div className="status status-error"></div>
      </div>
      {ERROR_TEXT[error]}
    </div>
  );
};
export default ErrMessage;
